import { OpenFeature } from '@openfeature/web-sdk'
import debug from '../console'
import { writeCustomDimensions } from './assertive-yield/customDimensions'
import {
  ENGAGEMENT_DIMENSION,
  packEngagement,
} from './assertive-yield/dimensions'
import {
  currentUserState,
  setUserStateEngagement,
} from './assertive-yield/userState'
import type { UserEngagementStateUpdate } from '../../store/userData/UserEngagementStore'

const logger = debug.withTag('updateUserEngagementTracking')

export const updateUserEngagementTracking = (
  state: UserEngagementStateUpdate
) => {
  const {
    isEngaged,
    daysSinceInstall,
    lastEngagementAction,
    daysSinceLastEngagement,
    installDate,
  } = state

  logger.info(`User engagement state updated: isEngaged: ${isEngaged}`)

  OpenFeature.setContext({
    ...OpenFeature.getContext(),
    isEngaged,
    daysSinceInstall,
    installDate,
  })

  setUserStateEngagement(isEngaged ? 'isEngaged' : 'notEngaged')
  writeCustomDimensions(() => {
    const patch: Record<string, unknown> = { userState: currentUserState() }
    const engagement = packEngagement(
      lastEngagementAction,
      daysSinceLastEngagement,
      daysSinceInstall
    )
    if (engagement !== null) {
      patch[ENGAGEMENT_DIMENSION] = engagement
    }
    return patch
  })

  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(() => {
    const targeting: Record<string, string> = {
      user_engagement: isEngaged ? 'isEngaged' : 'notEngaged',
    }
    if (daysSinceInstall !== null) {
      targeting.days_since_install = String(daysSinceInstall)
    }
    if (lastEngagementAction !== null) {
      targeting.engagement_action = lastEngagementAction
    }
    if (daysSinceLastEngagement !== null) {
      targeting.days_since_engagement = String(daysSinceLastEngagement)
    }
    window.googletag.setConfig({ targeting })
  })
}
